export default __webpack_public_path__ + "static/0018-6ccd8c8f10433fddcef2f878e8220528.png";